import { Reveal } from "./Reveal";
import { STEPS } from "@/data";

export const HowItWorks = () => (
  <section id="process" className="bg-cream text-ink py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-rust">How It Works</span>
        <h2 className="mt-5 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[0.95]">
          Three steps. One day. Zero hassle.
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-ink/10 border-t border-ink/10">
        {STEPS.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.1}>
            <div data-testid={`step-${s.no}`}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-10 items-start hover:bg-ink/[0.03] transition-colors -mx-4 px-4">
              <div className="md:col-span-3 font-display font-black text-6xl lg:text-8xl text-ink/10 group-hover:text-rust transition-colors">
                {s.no}
              </div>
              <h3 className="md:col-span-4 font-display font-bold text-2xl lg:text-3xl">{s.title}</h3>
              <p className="md:col-span-5 text-lg text-ink/60 leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
